import { render, staticRenderFns } from "./SettlementCorrections.vue?vue&type=template&id=e10bc8ac&"
import script from "./SettlementCorrections.vue?vue&type=script&lang=js&"
export * from "./SettlementCorrections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports